import * as THREE from 'three';

export default class Translate extends THREE.Mesh {
  static FOV = {
    width: window.innerWidth / 150,
    height: window.innerHeight / 180,
  };
  constructor(g, m) {
    super(g, m);
    this.startPosition = this.position.clone();
    this.endPosition = this.position.clone();
    this.endRotation = this.rotation.clone();
  }
  randomPosition(position = this.position) {
    // Position
    this.startPosition = position.clone();
    this.endPosition = this.startPosition.clone().add(new THREE.Vector3(
      (Math.sign(this.startPosition.x) * (Math.random() + 0.5) * Translate.FOV.width) / 3,
      (Math.sign(this.startPosition.y) * (Math.random() + 0.5) * Translate.FOV.height) / 3,
      0,
    ));
    this.position.copy(this.endPosition);
    this.endPosition.sub(this.startPosition);

    // Rotation
    const rotate = Math.random();
    this.endRotation = this.width > this.height ? new THREE.Euler(
      rotate > 0.25 ? (rotate - 0.5) * 10 * Math.PI : 0,
      0,
      0,
      'XYZ',
    ) : new THREE.Euler(
      0,
      rotate > 0.25 ? (rotate - 0.5) * 10 * Math.PI : 0,
      0,
      'XYZ',
    );
    this.rotation.copy(this.endRotation);
  }
  translate(translate = 0) {
    this.position.set(
      this.startPosition.x + (this.endPosition.x * translate),
      this.startPosition.y + (this.endPosition.y * translate),
      this.startPosition.z + (this.endPosition.z * translate),
    );
  }
  rotate(rotate = new THREE.Vector3(0)) {
    this.rotation.x = this.endRotation.x * (1 - rotate.x);
    this.rotation.y = this.endRotation.y * (1 - rotate.y);
    this.rotation.z = this.endRotation.z * (1 - rotate.z);
  }
}



// WEBPACK FOOTER //
// ./src/scene/Object/Translate.js